import {Segment} from "./segment";


export class SegmentPanel {

    static #showing = false;

    static showPanel() {
        let segmentDropdownDom = document.querySelector("#show-segment-panel .segment-dropdown");



        if (!this.#showing) {
            let self = this;
            setTimeout(function () {
                document.addEventListener("click", function (event) {
                    self.hidePanel();
                }, {once: true});
            }, 1);
        }


        let segmentsDom = Array.from(segmentDropdownDom.querySelectorAll("#show-segment-panel .segment-dropdown .segment-options a"));
        segmentsDom.forEach(segmentDom => {
            segmentDom.classList.remove("selected");
            if (Segment.getSegment(segmentDom.getAttribute("data-dimension-name")) !== null) {
                segmentDom.classList.add("selected");
            }
        });

        segmentDropdownDom.style.display = "block";
        this.#showing = true;
    }

    static hidePanel() {
        let segmentDropdownDom = document.querySelector("#show-segment-panel .segment-dropdown");
        segmentDropdownDom.style.display = "none";
        this.#showing = false;
    }
}

window.addEventListener("load", function () {
   let showPanelButton = document.querySelector("#show-segment-panel")

    if (showPanelButton !== null) {
        showPanelButton.addEventListener("click", function () {
            SegmentPanel.showPanel();
        });
    }
});